/**
 * Class name helper. Merges Tailwind classes safely (later classes override
 * earlier ones for the same Tailwind concern) while preserving non-Tailwind
 * classes verbatim.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
